// Estado global "backend fora do ar", alimentado pelas respostas HTTP (interceptor
// do axios em useAuth). Enquanto offline, toasts de erro/aviso são descartados e
// o ConnectionContext mostra a queda na sidebar.
let offline = false;
const listeners = new Set();

export const isBackendOffline = () => offline;

export const setBackendOffline = (value) => {
  if (offline === value) return;
  offline = value;
  listeners.forEach((listener) => listener(offline));
};

export const subscribeBackendStatus = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
